module.exports = __webpack_public_path__ + "static/img/index_bg_6.86b952c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/index_bg_6.jpg
// module id = 4edx
// module chunks = 9